import React from 'react';

import { Icon, IconAttention } from '@flixbus/honeycomb-icons-react';

import styles from './styles.module.css';

const WarningBanner = ({ children, action }) => {
	return (
		<div className={styles.warningBox}>
			<Icon extraClasses={styles.danger} InlineIcon={IconAttention} size={4} />
			<span className={styles.content}>{children}</span>
			{action}
		</div>
	);
};
export default WarningBanner;
